import { render } from "./inward_tracking.vue?vue&type=template&id=461dbd4e&scoped=true"
import script from "./inward_tracking.vue?vue&type=script&lang=js"
export * from "./inward_tracking.vue?vue&type=script&lang=js"

import "./inward_tracking.vue?vue&type=style&index=0&id=461dbd4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461dbd4e"]])

export default __exports__